import React, { useState } from "react"
import { Dialog } from "primereact/dialog"
import { Link } from "react-router-dom"
import { Button } from "primereact/button"
import _ from "lodash"

export default function TypeText({ value, name }) {
  const [visible, setVisible] = useState(false)
  switch (name) {
    case "demo_ssn":
      let maskedSSN = ""
      if (!_.isNull(value)) {
        maskedSSN = "XXX-XX-" + value.slice(-4)
      } else {
        maskedSSN = ""
      }

      return (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              padding: 0,
            }}
          >
            <span>{maskedSSN}</span>{" "}
            <Button
              label="Reveal"
              icon="pi pi-eye"
              onClick={() => setVisible(true)}
              className="p-button-sm"
              style={{ backgroundColor: "#8467ad" }}
            />
          </div>
          <Dialog
            header="Participant SSN"
            visible={visible}
            style={{ width: "50vw" }}
            onHide={() => setVisible(false)}
          >
            <p>{value}</p>
          </Dialog>
        </div>
      )
    default:
      return <div>{value} </div>
  }
}
